<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      :filter-items="filterItems"
      :get-data-func="getUsers"
      :headers="userHeaders"
      @click:row="goDetails('readonly',$event.item)"
      clickable
      ref="userList"
      search-text="搜索用户姓名"
      title-text="登记用户列表">
    </l-data-table>
  </l-layout>
</template>

<script>
  import {time} from '../../../ladmin/utils/time'

  export default {
    name: 'registerUser',
    data: () => ({
      userValid: false,
      selected: [],
      userDialog: {
        activate: false,
        form: {
          name: '',
          loginId: '',
          password: '',
          passwordAgain: ''
        },
        checkMessage: '',
        loading: false
      },
      floatingButton: false,
      moreActions: [
        {
          event: 'delete',
          label: '批量删除',
          icon: '$vuetify.icons.deleteAll'
        },
        // {
        //   event: 'bindGroup',
        //   label: '批量绑定用户组',
        //   icon: '$vuetify.icons.group'
        // },
        // {
        //   event: 'bindRole',
        //   label: '批量绑定角色',
        //   icon: '$vuetify.icons.role'
        // },
        // {
        //   event: 'export',
        //   label: '导出PDF',
        //   icon: '$vuetify.icons.description'
        // }
      ],
      filterItems: [
        {
          key: 'creationTime',
          value: {},
          label: '登记时间',
          type: 'duration',
          layout: ['xs12', 'sm4'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true
        },
        {
          prependIcon: '$vuetify.icons.person',
          key: 'loginId',
          value: '',
          label: '登录ID',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
        {
          prependIcon: '$vuetify.icons.phone',
          key: 'phone',
          value: '',
          label: '电话号码',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ],
      userHeaders: [
        {text: '用户姓名', value: 'name', align: 'left', placeholder: 'N/A'},
        {text: '用户账号', value: 'loginId', align: 'right', placeholder: 'N/A'},
        {text: '电话号码', value: 'phone', align: 'right', placeholder: 'N/A'},
        {text: '登记时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
        {text: '', value: '', align: 'right', width: '80px', sortable: false}
      ],
    }),
    methods: {
      msg (m) {
        console.log(m)
      },
      async getUsers ({pagination, sortStack, filterItems, search}) {
        return this.$store.dispatch('userAdmin/getUsers', {
          pagination,
          sortStack,
          filter: filterItems,
          search: {key: 'name', value: search}
        })
      },
      goDetails (status, item, force) {
        let selectionString = document.getSelection().toString()
        if (!selectionString || force) {
          if (status === 'new') {
            this.$router.push({name: 'NewUser'})
          }
          else {
            this.$router.push({
              name: 'registerUserDetailBox',
              query: {id: item.id,loginId: item.loginId}
            })
          }
        }
      },
      // async getTypes () {
      //   await this.$store.dispatch('userAdmin/getGroups', {type: 'reg', all: true, save: true, useCache: true})
      // }
    },
    // activated () {
    //   this.getTypes()
    // }
  }
</script>

<style scoped>

</style>
